import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        redirect: '/BrandIndex',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
        children: [
            {
                path: '/BrandIndex',
                name: 'BrandIndex',
                component: () => import(/* webpackChunkName: "index" */ '../views/main/Index.vue'),
            },
            {
                path: '/MallHomepage',
                name: 'MallHomepage',
                component: () => import(/* webpackChunkName: "index" */ '../views/main/indexTwo.vue'),
            },

            {
                path: '/login',
                name: 'Login',
                component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
            },
            {
                path: '/forget_password',
                name: 'ForgetPassword',
                component: () => import(/* webpackChunkName: "forget_password" */ '../views/ForgetPassword.vue'),
            },
            {
                path: '/register',
                name: 'Register',
                component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue'),
            },
            {
                path: '/index',
                name: 'Index',
                component: () => import(/* webpackChunkName: "index" */ '../views/main/Index.vue'),
            },


            {
                path: '/MallHomepage',
                name: 'MallHomepage',
                component: () => import(/* webpackChunkName: "index" */ '../views/main/indexTwo.vue'),
            },
            {
                path: '/weChatView',
                name: 'weChatView',
                component: () => import(/* webpackChunkName: "index" */ '../views/main/weChatView.vue'),
            },
            {
                path: '/IndexThree',
                name: 'IndexThree',
                component: () => import(/* webpackChunkName: "index" */ '../views/main/indexThree.vue'),
                children: [
                    {
                        path: '/goods',
                        name: 'Goods',
                        redirect: '/goods/goodsList',
                        component: () => import(/* webpackChunkName: "goods" */ '../views/main/goods/Index.vue'),
                        children: [
                            {
                                path: '/goods/GoodsHome',
                                name: 'GoodsHome',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/home.vue'),
                            },
                            {
                                path: '/goods/news',
                                name: 'GoodNews',
                                component: () => import(/* webpackChunkName: "member" */ '../views/main/goods/news/Index.vue'),
                                
                            },
                            {
                                path: '/goods/NewDetail',
                                name: 'GoodNewDetail',
                                component: () => import(/* webpackChunkName: "index" */ '../views/main/goods/news/Detail.vue'),
                            },
                            {
                                path: '/goods/Introduce',
                                name: 'GoodIntroduce',
                                component: () => import(/* webpackChunkName: "index" */ '../views/main/Introduce/index.vue'),
                            },
                            {
                                path: '/goods/ChangePwd',
                                name: 'ChangePwd',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/personalCenter/index.vue'),
                            },
                            {
                                path: '/goods/goodsList',
                                name: 'GoodShop',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/Goods.vue'),
                            },
                            {
                                path: '/goods/goodsCart',
                                name: 'GoodsCart',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/goodCart.vue'),
                            },
                            {
                                path: '/goods/goodsCartDB',
                                name: 'goodsCartDB',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/goodCartDB.vue'),
                            },
                            {
                                path: '/goods/goodCartOrder',
                                name: 'GoodCartOrder',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/goodCartOrder.vue'),
                            },

                            {
                                path: '/goods/goodOrderDetail',
                                name: 'goodOrderDetail',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/goodOrderDetail.vue'),
                            },
                            {
                                path: '/goods/goods_purchase',
                                name: 'GoodsPurchase',
                                component: () => import(/* webpackChunkName: "goods_purchase" */ '../views/main/goods/GoodsPurchase.vue'),
                            },
                            {
                                path: '/goods/goods_history',
                                name: 'GoodsHistory',
                                component: () => import(/* webpackChunkName: "goods_history" */ '../views/main/goods/GoodsHistory.vue'),
                            },
                            {
                                path: '/goods/Detail',
                                name: 'GoodsDetail',
                                component: () => import(/* webpackChunkName: "goods_detail" */ '../views/main/goods/Detail.vue'),
                            },
                            {
                                path: '/goods/DetailNew',
                                name: 'GoodsDetailNew',
                                component: () => import(/* webpackChunkName: "goods_detail" */ '../views/main/goods/DetailNew.vue'),
                            },
                            {
                                path: '/goods/DeatilProductingCommodity',
                                name: 'GoodsDeatilProductingCommodity',
                                component: () => import(/* webpackChunkName: "goods_detail" */ '../views/main/goods/DeatilProductingCommodity.vue'),
                            },
                            {
                                path: '/goods/DeatilXxd',
                                name: 'DeatilXxd',
                                component: () => import(/* webpackChunkName: "goods_detail" */ '../views/main/goods/DeatilXxd.vue'),
                            },
                            {
                                path: '/goods/DeatilTransportCommodity',
                                name: 'GoodsDeatilTransportCommodity',
                                component: () => import(/* webpackChunkName: "goods_detail" */ '../views/main/goods/DeatilTransportCommodity.vue'),
                            },
                            {
                                path: '/goods/DetailTui',
                                name: 'GoodsDetailTui',
                                component: () => import(/* webpackChunkName: "goods_detail" */ '../views/main/goods/DetailTui.vue'),
                            },
                            {
                                path: '/goods/DetailFD',
                                name: 'GoodsDetailFD',
                                component: () => import(/* webpackChunkName: "goods_detail" */ '../views/main/goods/DetailFD.vue'),
                            },

                            {
                                path: '/goods/cartItemDetail',
                                name: 'cartItemDetail',
                                component: () => import(/* webpackChunkName: "goods_cartItemDetail" */ '../views/main/goods/cartItemDetail.vue'),
                            },
                            {
                                path: '/goods/goodOrder',
                                name: 'GoodOrder',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/goodOrder.vue'),
                            },
                            {
                                path: '/goods/goodOrderDB',
                                name: 'goodOrderDB',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/goodOrderDB.vue'),
                            },
                            {
                                path: '/goods/imageGoodList',
                                name: 'ImageGoodList',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/imageGoodList.vue'),
                            },
                            {
                                path: '/goods/coCreationCenter',
                                name: 'CoCreationCenter',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/coCreationCenter.vue'),
                            },
                            {
                                path: '/goods/GoodFan',
                                name: 'GoodFan',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/GoodFan.vue'),
                            },
                            {
                                path: '/goods/imageGoodListDetail',
                                name: 'ImageGoodListDetail',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/imageGoodListDetail.vue'),
                            },
                            {
                                path: '/goods/imageGoodListDetails',
                                name: 'ImageGoodListDetailS',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/imageGoodListDetails.vue'),
                            },
                            {
                                path: '/goods/newGoodViewCounter',
                                name: 'newGoodViewCounter',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/newGoodViewCounter.vue'),
                            },
                            {
                                path: '/goods/repeatOrder',
                                name: 'repeatOrder',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/repeatOrder.vue'),
                            },
                            {
                                path: '/goods/hotGoodViewCounter',
                                name: 'hotGoodViewCounter',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/hotGoodViewCounter.vue'),
                            },
                            {
                                path: '/goods/XXDViewCounter',
                                name: 'XXDViewCounter',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/XXDViewCounter.vue'),
                            },
                            {
                                path: '/goods/XXDViewCounterNav',
                                name: 'XXDViewCounterNav    ',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/XXDViewCounterNav.vue'),
                            },
                            {
                                path: '/goods/inTransitPreSale',
                                name: 'inTransitPreSale',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/zaituyushouGoodViewCouter.vue'),
                            },
                            {
                                path: '/goods/inTransitPreSaleNav',
                                name: 'inTransitPreSaleNav',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/zaituyushouGoodViewCouterNav.vue'),
                            },
                            {
                                path: '/goods/inProductionPreSaleNav',
                                name: 'inProductionPreSaleNav',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/zaichanyushouGoodViewCounterNav.vue'),
                            },
                            {
                                path: '/goods/inProductionPreSale',
                                name: 'inProductionPreSale',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/zaichanyushouGoodViewCounter.vue'),
                            },
                            {
                                path: '/goods/goodCartOrderBuy',
                                name: 'goodCartOrderBuy',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/goodCartOrderBuy.vue'),
                            },
                            {
                                path: '/goods/goodCartOrderBuyDB',
                                name: 'goodCartOrderBuyDB',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/goodCartOrderBuyDB.vue'),
                            },
                            {
                                path: '/goods/tuiGoodViewCounter',
                                name: 'tuiGoodViewCounter',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/tuiGoodViewCounter.vue'),
                            },
                            {
                                path: '/goods/activityDetail',
                                name: 'activityDetail',
                                component: () => import(/* webpackChunkName: "goods_index" */ '../views/main/goods/activityDetail.vue'),
                            },
                        ]
                    },
                ]
            },
 
        
            {
                path: '/news',
                name: 'News',
                component: () => import(/* webpackChunkName: "member" */ '../views/main/news/Index.vue'),
                
            },
            { 
                path: '/NewDetail',
                name: 'NewDetail',
                component: () => import(/* webpackChunkName: "index" */ '../views/main/news/Detail.vue'),
            },
            {
                path: '/Introduce',
                name: 'Introduce',
                component: () => import(/* webpackChunkName: "index" */ '../views/main/Introduce/index.vue'),
            },
            {
                path: '/about',
                name: 'Abouts',
                component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
            },
            {
                path: '/ad',
                name: 'Ad',
                component: () => import(/* webpackChunkName: "ad" */ '../views/Ad.vue'),
            }
        ]
    },
    {
        path: '/wxLogin',
        name: 'WxLogin',
        component: () => import(/* webpackChunkName: "register" */ '../views/WxLogin.vue'),
    },
 
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(r => r.meta.requireAuth)) {
        var token = localStorage.getItem('dftToken');
        if (token) {
            next();
        }
        else {
            next({
                path: '/login',
                query: { redirect: to.path }
            })
        }
    }
    else {
        next();
    }
})

export default router
